import { SnackbarFunctionProps } from '@lyearn/ui';
import { onAction } from '@/components/EditorBuilder/types';
import { ItemType } from '@/modules/corporate/components/Settings/types';
import {
  ArticleContentType,
  CourseContentType,
  PublishContentConfig,
  ResourceStatusEnum,
} from '@/types/schema';

import useSetDialogs from './hooks/useSetDialogs';

type ContentType = ArticleContentType | CourseContentType;

export type onPublishType = (publishConfig: PublishContentConfig) => Promise<void>;
export type DialogProps = Omit<DialogsProps, 'activeDialog'>;

export interface DialogsProps {
  activeDialog: DialogComponent;
  content: ContentType;
  onClose: () => void;
  onSubmit?: (content: any, snackbarProps?: SnackbarFunctionProps) => void;
  item?: ItemType;
}

export interface SettingsProps {
  content: ContentType;
  onSubmit?: (content: any, snackbarProps?: SnackbarFunctionProps) => void;
  uploadFileJobId?: string | null;
  uploadFileUrl?: string | null;
  setDialog: ReturnType<typeof useSetDialogs>['setDialog'];
  activeDialog: ReturnType<typeof useSetDialogs>['activeDialog'];
  settingsEnabled: boolean;
}

export interface MenuProps {
  setActiveDialog: (value: any) => void;
  contentStatus: ResourceStatusEnum;
  uploadFileJobId?: string | null;
  uploadFileUrl?: string | null;
  settingsEnabled: boolean;
  isLocalizedContent?: boolean;
  isPointsAndBadgesEnabled?: boolean;
}

export type DialogComponent = React.ComponentType<DialogProps>;

export type SetDialogProps = {
  onAction: onAction;
};

export enum Dialogs {
  Author = 'Author',
  AttachMGS = 'AttachMGS',
  Import = 'Import',
  VisibilitySettings = 'VisibilitySettings',
  Tags = 'Tags',
  RevertChanges = 'RevertChanges',
  VersionHistory = 'VersionHistory',
  WorkspaceSettings = 'WorkspaceSettings',
  AssignmentRestriction = 'AssignmentRestriction',
  Assign = 'Assign',
  AttachCategories = 'AttachCategories',
  Languages = 'Languages',
  PointsAndBadges = 'PointsAndBadges',
}
